import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {View, Box, Text} from "@unibuddy/patron";
import {useLocation} from "react-router-dom";

import {UnibuddyLogoInlineSvg} from "./UnibuddyLogoInlineSvg";
import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_DONT_HAVE_ACCOUNT,
    INTL_WELCOME_BACK,
    INTL_CREATE_ACCOUNT,
} from "../../../../translations/login";
import {ThemedRelativeLink} from "./ThemedRelativeLink";

export function LoginPageHeading() {
    const {t} = useTranslation(IntlNamespaces.LOGIN);
    const registerText = t(
        `${IntlNamespaces.LOGIN}:${INTL_CREATE_ACCOUNT.key}`,
        INTL_CREATE_ACCOUNT.defaultValue,
    );
    const dontHaveAnAccountText = t(
        `${IntlNamespaces.LOGIN}:${INTL_DONT_HAVE_ACCOUNT.key}`,
        INTL_DONT_HAVE_ACCOUNT.defaultValue,
    );

    const location = useLocation();

    return (
        <View gap="small-medium" alignItems="center">
            <UnibuddyLogoInlineSvg />
            <Text size="large" align="center" weight="700">
                {t(
                    `${IntlNamespaces.LOGIN}:${INTL_WELCOME_BACK.key}`,
                    INTL_WELCOME_BACK.defaultValue,
                )}{" "}
                &nbsp;
            </Text>
            <Box display="flex" alignItems="center">
                <Text size="small">{dontHaveAnAccountText} &nbsp;</Text>
                <Text>
                    <ThemedRelativeLink
                        to={{
                            pathname: location.pathname.replace("login", "register"),
                            search: location.search,
                            state: location.state,
                        }}
                    >
                        {registerText}
                    </ThemedRelativeLink>
                </Text>
            </Box>
        </View>
    );
}
